import { render, staticRenderFns } from "./ModalTranfer.vue?vue&type=template&id=4dd681b8&scoped=true"
import script from "./ModalTranfer.vue?vue&type=script&lang=js"
export * from "./ModalTranfer.vue?vue&type=script&lang=js"
import style0 from "./ModalTranfer.vue?vue&type=style&index=0&id=4dd681b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd681b8",
  null
  
)

export default component.exports